var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppData } from '@hellodarwin/core/lib/features/providers/app-data-provider';
import Tooltip from 'antd/es/tooltip';
import { useMemo } from 'react';
import useHandleLinkClick from '../utils/use-handle-link-click';
import MenuItemLabel from './menu-item-label';
import { NavigationMenuItemStyled } from './styles';
import SubitemsListDropdown from './subitems-list-dropdown';
const NavigationMenuItem = (_a) => {
    var { selectedKeys, setSelectedKeys, isMobile } = _a, props = __rest(_a, ["selectedKeys", "setSelectedKeys", "isMobile"]);
    const { subLinks, pathname, label } = props;
    const { navCollapsed } = useAppData();
    const isCollapsed = isMobile ? false : navCollapsed;
    const handleLinkClick = useHandleLinkClick({
        selectedKeys,
    });
    const handleListItemsOpen = () => {
        if (isCollapsed) {
            setSelectedKeys === null || setSelectedKeys === void 0 ? void 0 : setSelectedKeys([pathname]);
        }
        else {
            setSelectedKeys === null || setSelectedKeys === void 0 ? void 0 : setSelectedKeys((prevSelectedKeys) => [...prevSelectedKeys, pathname]);
        }
    };
    const handleListItemsClose = () => {
        setSelectedKeys === null || setSelectedKeys === void 0 ? void 0 : setSelectedKeys((prevSelectedKeys) => prevSelectedKeys.filter((key) => key !== pathname));
    };
    const isSubmenuOpen = useMemo(() => {
        return Boolean(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.includes(pathname));
    }, [selectedKeys, pathname]);
    const toggleSubmenu = () => {
        if (isSubmenuOpen) {
            handleListItemsClose();
        }
        else {
            handleListItemsOpen();
        }
    };
    return (_jsxs(NavigationMenuItemStyled, { "$isCollapsed": isCollapsed, onMouseEnter: isCollapsed ? handleListItemsOpen : undefined, children: [isCollapsed && !(subLinks === null || subLinks === void 0 ? void 0 : subLinks.length) ? (_jsx(Tooltip, { title: label, placement: "right", children: _jsx("div", { children: _jsx(MenuItemLabel, Object.assign({}, props, { handleLinkClick: handleLinkClick, handleListItemsOpening: toggleSubmenu, listItemsOpen: isSubmenuOpen, isCollapsed: isCollapsed })) }) })) : (_jsx(MenuItemLabel, Object.assign({}, props, { handleListItemsOpening: toggleSubmenu, listItemsOpen: isSubmenuOpen, handleLinkClick: handleLinkClick, isCollapsed: isCollapsed }))), !!subLinks && (_jsx(SubitemsListDropdown, { style: { width: '100%' }, isCollapsed: isCollapsed, handleDropdownMouseLeave: handleListItemsClose, isActive: isSubmenuOpen, items: subLinks, isDropdown: isCollapsed, parentItem: props }))] }));
};
export default NavigationMenuItem;
